import { createCrudHooks } from './use-crud-factory'
import type { ThemePreset } from '@/types/database.types'

/* ============================================================
   useThemePresets — PRD §9 (Theme Engine)
   Theme preset loading and saving.
   ============================================================ */

const {
  useList: useThemePresetList,
  useOne: useThemePreset,
  useCreate: useCreateThemePreset,
  useUpdate: useUpdateThemePreset,
  useDelete: useDeleteThemePreset,
} = createCrudHooks<ThemePreset>({
  table: 'theme_presets',
  queryKey: 'theme-presets',
  orderBy: 'name',
  orderAsc: true,
})

export {
  useThemePresetList,
  useThemePreset,
  useCreateThemePreset,
  useUpdateThemePreset,
  useDeleteThemePreset,
}

export { useThemePresetList as useThemePresets }
